// services/MotoristaService.js
import HttpService from "./HttpService";

class DriverService extends HttpService {
  getDrivers() {
    return this.get(`/drivers`).then((response) => response.data);
  }

  getDriverById(id) {
    return this.get(`/drivers/${id}`).then((response) => response.data);
  }

  createDriver(data) {
    return this.post("/drivers", data);
  }

  updateDriver(id, data) {
    return this.put(`/drivers/${id}`, data);
  }

  toInactiveDriver(uuid) {
    return this.put(`/drivers/${uuid}/inactive`);
  }

  toActiveDriver(uuid) {
    return this.put(`/drivers/${uuid}/active`);
  }

  verifyDriver(cpf, email) {
    return this.post(`/drivers/verificar`, { cpf, email });
  }

  loginDriver(email, cpf, password) {
    return this.post(`/drivers/login`, { email, cpf, password }).then(
      (response) => {
        if (response.data.access_token) {
          localStorage.setItem("token", response.data.access_token);
          localStorage.setItem("user", JSON.stringify(response.data.user));
        }
        return response.data;
      }
    );
  }

  async createSubmission(data) {
    return await this.post("/drivers/coupled", data);
  }

  async autoComplete(searchQuery) {
    return await this.get(`/drivers/search/autocomplete`, {
      params: {
        page: searchQuery.page,
        limit: searchQuery.limit,
        search: searchQuery.search,
      },
    }).then((response) => response.data);
  }

  async addVeiculos(data) {
    return await this.post("/drivers/vehicles", data).then(
      (response) => response.data
    );
  }
}

export default DriverService;
